import React from 'react';
export const TestimonialsSection: React.FC = () => {
  const testimonials = [{
    initials: 'JP',
    bg: 'bg-brown-mid',
    name: 'Juan P. · Mega Pack Tierra Viva',
    location: '📍 Salta, Argentina',
    quote: '"Pensé que construir en barro era para románticos sin criterio técnico. Con el Tomo 2 entendí la ingeniería real. Mi casa de quincha sobrevivió un sismo de 6.2 sin una sola grieta."'
  }, {
    initials: 'MS',
    bg: 'bg-green-mid',
    name: 'Marina S. · Mega Pack Tierra Viva',
    location: '📍 Montevideo, Uruguay',
    quote: '"La calculadora Eco-Estimator me ahorró una fortuna en fletes. No compré un kilo de arena de más. El Tomo 3 de acabados con el Tadelakt es simplemente magia. Mis paredes parecen de hotel boutique."'
  }, {
    initials: 'RM',
    bg: 'bg-brown-dark',
    name: 'Roberto M. · Mega Pack Tierra Viva',
    location: '📍 Santiago, Chile',
    quote: '"La Guía de Legalidad fue el factor clave. Fui al municipio usando el vocabulario técnico del bono y me aprobaron el proyecto en 3 semanas. Sin esa guía, seguiría dando vueltas."'
  }, {
    initials: 'CA',
    bg: 'bg-brown-light',
    name: 'Claudia A. · Mega Pack Tierra Viva',
    location: '📍 Córdoba, Argentina',
    quote: '"El Plan de 30 Días fue lo que me faltaba. Yo tenía el entusiasmo pero no el sistema. Semana a semana, día a día. Hoy tengo los muros a un metro de altura y no paro."'
  }];
  return <section className="bg-white py-20 px-5 text-center" data-id="element-257">
      <h2 className="text-[clamp(22px,3.5vw,36px)] text-[#1A1A1A] mb-10" data-id="element-258">
        ❤️ Más Autoconstructores que ya Empezaron
      </h2>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-[22px] max-w-[1000px] mx-auto" data-id="element-259">
        {testimonials.map((t, i) => <div key={i} className="bg-[#FAFAF5] rounded-2xl p-7 text-left border-t-4 border-green-brand shadow-[0_4px_20px_rgba(0,0,0,0.05)]" data-id="element-260">
            <div className="flex items-center gap-3 mb-[15px]" data-id="element-261">
              <div className={`w-[46px] h-[46px] rounded-full flex items-center justify-center font-black font-sans text-sm text-white shrink-0 ${t.bg}`} data-id="element-262">
                {t.initials}
              </div>
              <div className="flex-1" data-id="element-263">
                <div className="font-bold text-sm text-[#1A1A1A] font-sans" data-id="element-264">
                  {t.name}
                </div>
                <div className="text-xs text-[#999] font-sans" data-id="element-265">
                  {t.location}
                </div>
              </div>
            </div>
            <div className="text-gold-main text-[15px] tracking-[1px] mb-3" data-id="element-266">
              ★★★★★
            </div>
            <p className="text-sm text-[#444] font-sans italic leading-[1.7]" data-id="element-267">
              {t.quote}
            </p>
          </div>)}
      </div>
    </section>;
};